/**
 * RegistrationPage
 *
 * Story 15: Registration Page Routes
 *
 * Main page for provider registration with invite code validation
 *
 * Features:
 * - Render RegistrationWizard component
 * - Handle registration completion
 * - Redirect authenticated users to dashboard
 * - Public route (no authentication required)
 * - Mobile-responsive layout
 */

import { useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { RegistrationWizard } from '../components/RegistrationWizard/RegistrationWizard';

export function RegistrationPage() {
  const navigate = useNavigate();

  // Check if user is already authenticated
  useEffect(() => {
    const authToken = localStorage.getItem('authToken');
    if (authToken) {
      // User is already authenticated, redirect to dashboard
      navigate('/provider/dashboard', { replace: true });
    }
  }, [navigate]);

  return (
    <div className="min-h-screen bg-neutral-50 py-8">
      <div className="container mx-auto px-4">
        <div className="max-w-3xl mx-auto">
          <RegistrationWizard />

          {/* Link to Request Invite */}
          <div className="mt-6 text-center">
            <p className="text-sm text-neutral-600">
              Don&apos;t have an invite code?{' '}
              <Link
                to="/provider/request-invite"
                className="font-medium text-primary-600 hover:text-primary-700"
              >
                Request one here
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
